export default __webpack_public_path__ + "static/O0118-72b4e40e415e33ed97fe9af1acd76a08.png";